<script>
	import calendarize from 'calendarize'
	import tinydate from 'tinydate'
	import { cubicOut, cubicInOut } from 'svelte/easing'

	const yearMonthStamp = tinydate('{YYYY}{MM}')
	const yearMonthDayStamp = tinydate('{YYYY}{MM}{DD}')

	export let shows = []
	export let ticketUrl = ''

	let showDates = {}

	shows.forEach(show => {
		show.showTimes.forEach(showTime => {
			let showTimeStamp = `${showTime.y}${showTime.m}${showTime.d}`
			if (!showDates[showTimeStamp]) {
				showDates[showTimeStamp] = []
			}
			showDates[showTimeStamp].push(
				Object.assign(showTime, {
					image: show.image,
					name: show.name,
					url: show.url,
				})
			)
		})
	})

	let date = new Date()

	// width of calendar
	let width

	// eg 20200219
	let today = yearMonthDayStamp(new Date())

	let daysOfWeek = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	]

	$: calWeeks = calendarize(date)

	$: monthHeading = date.toLocaleString('en-US', {
		month: 'long',
		year: 'numeric',
	})

	// eg 202002
	$: yearMonth = yearMonthStamp(date)

	function subtractMonth() {
		date.setMonth(date.getMonth() - 1, 1)
		date = new Date(date)
	}
	function addMonth() {
		date.setMonth(date.getMonth() + 1, 1)
		date = new Date(date)
	}

	function showTippy(e, shows, day) {
		let el = e.target
		if (el._tippy) {
			el._tippy.show()
			return
		}
		window.tippy(e.target, {
			content: `<h3>${shows
				.map(show => show.name + ' - ' + show.t + '<br>')
				.join('')}</h3>`,
			duration: 270,
			theme: 'purple',
			distance: 2,
		})
		el._tippy.show()
	}
</script>

<div class="calendar" bind:offsetWidth={width}>
	<div class="header calrow flex-middle">
		<div class="calcol calcol-start">
			<button class="icon prev" on:click={subtractMonth}>
				<svg viewBox="0 0 478 478">
					<path d="M132 0l-32 32 214 207-214 207 32 32 246-239z" />
				</svg>
				<span class="sr-only">Previous Month</span>
			</button>
		</div>
		<div class="calcol calcol-center">
			<span>{monthHeading}</span>
		</div>
		<div class="calcol calcol-end">
			<button class="icon" on:click={addMonth}>
				<svg viewBox="0 0 478 478">
					<path d="M132 0l-32 32 214 207-214 207 32 32 246-239z" />
				</svg>
				<span class="sr-only">Previous Month</span>
			</button>
		</div>
	</div>

	<div class="days calrow">
		{#each daysOfWeek as dayName}
			<div class="calcol calcol-center">
				{width > 700 ? dayName : dayName.substr(0, 3)}
			</div>
		{/each}
	</div>
	<div class="calbody">
		{#each calWeeks as week (`${yearMonth}${week}`)}
			<div class="calrow">
				{#each week as day}
					<div
						class="calcol cell"
						class:is-today={`${yearMonth}${String(day).length < 2 ? `0${day}` : day}` === today}
						class:has-show={showDates[`${yearMonth}${day}`]}
						class:is-past={`${today}` > `${yearMonth}${String(day).length < 2 ? `0${day}` : day}`}>
						{#if day}
							<span class="bg">{day}</span>
							<span class="number">{day}</span>
							{#if showDates[`${yearMonth}${day}`]}
								<!-- if show on date -->

								<a
									href={ticketUrl ? ticketUrl : showDates[`${yearMonth}${day}`][0].url}
									target={ticketUrl ? "_blank" : "_self"}
									class="show-cell talha"
									style="background-image:url({showDates[`${yearMonth}${day}`][0].image})"
									on:mouseenter={e => showTippy(e, showDates[`${yearMonth}${day}`], day)}
									on:focus={e => showTippy(e, showDates[`${yearMonth}${day}`], day)}>
									<span class="sr-only">
										<h3>{`${monthHeading.split(' ')[0]} ${day}`}</h3>
										{showDates[`${yearMonth}${day}`][0].name}
										{showDates[`${yearMonth}${day}`]
											.map(show => show.t)
											.join(' | ')}
									</span>

									{#if [...new Set(showDates[`${yearMonth}${day}`].map(item => item.image))].length >= 2}
										{#each [...new Set(showDates[`${yearMonth}${day}`].map(item => item.image))] as item}
											<div
												style="background-image: url({item})"
												class="show-cell-img show-cell-img-split" />
										{/each}
									{:else}
										{#each [...new Set(showDates[`${yearMonth}${day}`].map(item => item.image))] as item}
											<div
												style="background-image: url({item})"
												class="show-cell-img" />
										{/each}
									{/if}

								</a>
							{/if}
						{/if}
					</div>
				{/each}
			</div>
		{/each}
	</div>
</div>